"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Wrench, PenTool, Search, Waves, Flame, CircleAlert, ArrowRight } from "lucide-react";
const services = [{
  title: "Kitchen Remodeling",
  description: "Bespoke culinary spaces blending high-end cabinetry with professional-grade functionality.",
  icon: Flame,
  href: "/OurPortfolioPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/kitchen_remodeling.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/kitchen_remodeling.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/kitchen_remodeling.png-wvc-sizes"
}, {
  title: "Luxury Additions",
  description: "Seamless architectural expansions that enhance your home's footprint and market value.",
  icon: PenTool,
  href: "/OurPortfolioPage",
  image: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/addition.png?v=zxg19bikcfj",
  srcset: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/addition.png?v=bgokozj8htl-wvc-srcset",
  sizes: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/addition.png?v=297qnutts1e-wvc-sizes"
}, {
  title: "ADU Construction",
  description: "Custom accessory dwelling units designed for modern living and long-term versatility.",
  icon: Wrench,
  href: "/OurPortfolioPage",
  image: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/Building-an-ADU-in-San-Carlos-for-Family-Members.jpg?v=gzi7jtqt0oq",
  srcset: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/Building-an-ADU-in-San-Carlos-for-Family-Members.jpg?v=xds578de0pf-wvc-srcset",
  sizes: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/Building-an-ADU-in-San-Carlos-for-Family-Members.jpg?v=t8req8lija-wvc-sizes"
}, {
  title: "Bathroom Retreats",
  description: "Spa-inspired sanctuaries featuring premium stone, custom glass, and precision plumbing.",
  icon: Waves,
  href: "/OurPortfolioPage",
  image: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/image9-rotated.jpeg?v=hm1yvdjped8",
  srcset: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/image8-rotated.jpeg?v=8gmdjlstlov-wvc-srcset",
  sizes: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/image8-rotated.jpeg?v=g9sflpkmg3q-wvc-sizes"
}, {
  title: "Design & Rendering",
  description: "Advanced 3D modeling and floor plan design to visualize your masterpiece before building.",
  icon: Search,
  href: "/OurPortfolioPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/design_rendering.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/design_rendering.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/design_rendering.png-wvc-sizes"
}, {
  title: "Whole Home Remodels",
  description: "Comprehensive structural transformations executed with master-level craftsmanship.",
  icon: CircleAlert,
  href: "/OurPortfolioPage",
  image: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/45668771_266282717354062_7196435094217687040_n.jpg?v=2kiwx045s5r",
  srcset: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/45668771_266282717354062_7196435094217687040_n.jpg?v=0jz5r96rbrkf-wvc-srcset",
  sizes: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/45668771_266282717354062_7196435094217687040_n.jpg?v=m7oxo15tofi-wvc-sizes"
}];
export default function ExpertSolutionsForEveryPipe() {
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    e.currentTarget.style.setProperty("--mouse-x", `${x}px`);
    e.currentTarget.style.setProperty("--mouse-y", `${y}px`);
  };
  return <section data-section-id="223683" id="our-specialized-expertise" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 max-w-2xl">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight mb-4 text-primary">
            Our Specialized Expertise
          </h2>
          <p className="font-sans text-muted-foreground text-xl leading-relaxed">
            Modern architectural luxury meets master craftsmanship. We specialize in high-end residential transformations across the Denver metro area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={service.title} data-index={index} onMouseMove={handleMouseMove} className="group relative flex h-full flex-col overflow-hidden rounded-md border border-border bg-card transition-all duration-500 hover:border-secondary hover:shadow-xl">
                <div className="pointer-events-none absolute -inset-px opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
              background: `radial-gradient(600px circle at var(--mouse-x, 0) var(--mouse-y, 0), rgba(35, 40, 55, 0.03), transparent 40%)`
            }} />
                
                <Card className="flex h-full flex-col border-none bg-transparent">
                  <CardHeader className="pb-4 px-0">
                    <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.title} className="w-full h-56 object-cover mb-6 rounded-t-md" loading="lazy" decoding="async" />
                    <div className="px-6">
                      <div className="mb-4 inline-flex size-12 items-center justify-center rounded-md bg-secondary/10 text-secondary ring-1 ring-secondary/20 transition-transform duration-500 group-hover:scale-110">
                        <Icon className="size-6" strokeWidth={1} />
                      </div>
                      <CardTitle className="font-default text-2xl font-bold text-primary">
                        {service.title}
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent className="flex-grow pb-6">
                    <p className="font-sans text-muted-foreground leading-relaxed text-base">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 mt-auto">
                    <Link to={service.href} className="group/link inline-flex items-center gap-2 font-sans text-sm font-bold uppercase tracking-widest text-secondary transition-colors hover:text-primary">
                      View Project
                      <ArrowRight className="size-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}